export interface Provider {
    providerId?: number;
    name: string;
    description: string;
    logoPath?: string;
    address: ProviderSite;
    programs: Program[];
    countiesServed: string[];
    selected: boolean;
    webSite: string;
    sites: ProviderSite[];
    selectedSiteIds: number[];
    isWaitlist: boolean;
}

export interface Program {
    programId?: number;
    name: string;
    description: string;
}

export class ProviderSearch {
    searchText: string = '';
    programIds: number[] = [];
    address: string = '';
    distance: number = 0;
    sort: string = '';

    get filtered() {
        return (
            this.searchText.length > 0 ||
            this.programIds.length > 0 ||
            (this.address.length > 0 && this.distance > 0)
        );
    }
}

export interface ProviderSite extends Address {
    siteId: number;
    siteName: string;
}

export interface Address {
    addressId?: number;
    streetAddress: string;
    aptSuiteOther: string;
    city: string;
    stateCode: string;
    postalCode: string;
}
